import script from "./PasswordVergessenView.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordVergessenView.vue?vue&type=script&setup=true&lang=js"

import "./PasswordVergessenView.vue?vue&type=style&index=0&id=0c1015dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c1015dc"]])

export default __exports__